import {
    apiRequest,
    AcSosioculturalCreate,
    AcSosioculturalEmployee,
    AcSosioculturalPeriod,
    AcSosioculturalKinerja,
    AcSosioculturalStankom,
    AcSosioculturalEmployeeDetail,
    AcSosioculturalLevelCompetence
} from "../../../../../services/adapters/Assesment/assesmentService"

class CreateRepository {

    fetchCreate = async (query) => {
        return await apiRequest("post", AcSosioculturalCreate, {
            body: query
        }, true)
    }

    // fetchCategories = async (query) => {
    //     return await apiRequest("get", masterCategories, {
    //         params: query
    //     }, true)
    // }
    fetchEmployee = async (query) => {
        return await apiRequest("get", AcSosioculturalEmployee, {
            params: query
        }, true)
    }
    fetchPeriod = async (query) => {
        return await apiRequest("get", AcSosioculturalPeriod, {
            params: query
        }, true)
    }
    fetchPerformance = async (query) => {
        return await apiRequest("get", AcSosioculturalKinerja, {
            params: query
        }, true)
    }
    fetchStankom = async (query) => {
        return await apiRequest("get", AcSosioculturalStankom, {
            params: query
        }, true)
    }
    fetchDetailEmployee = async (query) => {
        return await apiRequest("get", AcSosioculturalEmployeeDetail, {
            params: query
        }, true)
    }
    fetchStankom = async (query) => {
        return await apiRequest("get", AcSosioculturalStankom, {
            params: query
        }, true)
    }
    fetcLevelCompetence = async (query) => {
        return await apiRequest("get", AcSosioculturalLevelCompetence, {
            params: query
        }, true)
    }
}

export default CreateRepository